import { render, staticRenderFns } from "./SignInConnectedAccountForm.vue?vue&type=template&id=5c5bec6a&scoped=true"
import script from "./SignInConnectedAccountForm.vue?vue&type=script&lang=ts"
export * from "./SignInConnectedAccountForm.vue?vue&type=script&lang=ts"
import style0 from "./SignInConnectedAccountForm.vue?vue&type=style&index=0&id=5c5bec6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5bec6a",
  null
  
)

export default component.exports